import { useState, useEffect } from 'react';
import { Modal, Flex, Button, Text, Input } from '@mantine/core';

interface NewDeleteConfirmModalProps {
  idPrefix?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (callback: () => void) => void;
  isLoading: boolean;
  title: string;
  description: string;
  submitLabel: string;
  cancelLabel: string;
  type: string;
}

export function NewDeleteConfirmModal({
  idPrefix,
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  description,
  submitLabel,
  cancelLabel,
  type
}: NewDeleteConfirmModalProps) {
  const [value, setValue] = useState('');
  const rootId = idPrefix || 'new-delete-confirm-modal';

  useEffect(() => {
    if (!isOpen) setValue('');
  }, [isOpen]);

  const onCloseModal = () => {
    setValue('');
    onClose();
  };

  const handleConfirmClick = () => {
    onConfirm(() => {
      setValue('');
    });
  };

  return (
    <Modal
      id={`${rootId}-modal`}
      opened={isOpen}
      radius="sm"
      withCloseButton
      onClose={onCloseModal}
      centered
      title={title}
      size="320"
      styles={{
        header: {
          padding: '16px 16px 8px 16px',
          minHeight: 'auto'
        },
        title: {
          fontSize: '16px',
          lineHeight: '22px'
        }
      }}
    >
      <Text
        id={`${rootId}-description`}
        fz="14px"
        fw="400"
        c="var(--dx-c-gray-7)"
        style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
      >
        {description}
      </Text>
      <Flex id={`${rootId}-confirm-group`} mt="24px" direction="column" gap="4px">
        <Text id={`${rootId}-confirm-label`} fz="14px" lh="20px" fw="600" c="var(--dx-c-dark-6)">
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Type "{type}" to confirm
        </Text>
        <Input id={`${rootId}-input`} onChange={e => setValue(e.target.value)} value={value} />
      </Flex>
      <Flex id={`${rootId}-actions`} gap="16px" mt="24px">
        <Button
          id={`${rootId}-cancel`}
          miw="80px"
          variant="default"
          onClick={onCloseModal}
          size="sm"
        >
          {cancelLabel}
        </Button>
        <Button
          id={`${rootId}-confirm`}
          disabled={value !== type}
          onClick={handleConfirmClick}
          loading={isLoading}
          size="sm"
          color="red"
          w="100%"
        >
          {submitLabel}
        </Button>
      </Flex>
    </Modal>
  );
}
